module.exports = __webpack_public_path__ + "static/icon-pecan-de3e1bc35e8bfb478aef26380dc201c2.png";